export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11482.3a9dc376.jpg";